import React from "react";
import Banner from "../components/banner/banner";
import PartnerSection from "../components/PartnerSection/partner";
import ROI from "../components/ROISection/ROI";
import UseCases from "../components/UseCasesSection/UseCases";
import FooterSection from "../components/FooterSection/footer";
import SecondBanner from "../components/SecondBannerSection/SecondBanner";
import SolutionSection from "../components/SolutionSection/SolutionSection";
import BenefitsSection from "../components/BenefitsSection/BenefitsSection";
import Features from "../components/Features/Features";
export default function AgentInstruct() {
  return (
    <>
      <Banner />
      <PartnerSection />
      <SolutionSection />
      <BenefitsSection />
      <ROI />
      <UseCases />
      <Features />
      <SecondBanner />
      <FooterSection />
    </>
  );
}
